import DocumentListContent from './DocumentListContent';

export default DocumentListContent;
